var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row no-gutters pr-3"},[(_vm.sortedDependents.length > 0)?_vm._l((_vm.sortedDependents),function(dependent,index){return _c('div',{key:index,staticClass:"col-md-6 mb-2 p-0"},[_c('dependent-details-card',{attrs:{"cardData":dependent},on:{"clicked":function($event){return _vm.showData(dependent)}}})],1)}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }